import React from "react";

const Background = ({ children }) => {
  return (
    <div className="bg-white dark:bg-[#0d0c11] transition-all dark:min-h-screen dark:md:min-h-screen dark:lg:min-h-screen">
      {children}
    </div>
  );
};

export default Background;
